import { Reducer } from '@reduxjs/toolkit'

import {
    RECEIVE_TAX_CONSULTATION,
    RECEIVE_TAX_CONSULTATION_AGREEMENT,
    RECEIVE_TAX_CONSULTATIONS,
    REMOVE_TAX_CONSULTATION,
    REQUEST_TAX_CONSULTATIONS,
} from '@/actions'
import { removeItemsById, updateOrAddItemsById } from '@/helpers'
import { TaxConsultationsSlice } from '@/models/tax-consultation'

const initialState = {
    agreements: [],
    fetchSuccessful: false,
    hasSelectedToUpgradeToBundle: false,
    isFetching: false,
    items: [],
}

const taxConsultationsReducer: Reducer<TaxConsultationsSlice> = (currentState, { type, data }) => {
    const state = currentState ?? initialState

    switch (type) {
        case REQUEST_TAX_CONSULTATIONS:
            return { ...state, isFetching: true }

        case RECEIVE_TAX_CONSULTATIONS: {
            return { ...state, ...data, isFetching: false }
        }

        case RECEIVE_TAX_CONSULTATION: {
            const items = updateOrAddItemsById({ currentItems: state.items, receivedItems: data.items })
            return { ...state, ...data, items }
        }

        case REMOVE_TAX_CONSULTATION: {
            const items = removeItemsById({ currentItems: state.items, id: data.taxConsultationId })
            return { ...state, ...data, items }
        }

        case RECEIVE_TAX_CONSULTATION_AGREEMENT: {
            const agreements = updateOrAddItemsById({
                currentItems: state.agreements,
                receivedItems: data.agreements,
                idKey: 'taxConsultationId',
            })
            return { ...state, agreements }
        }

        default:
            return state
    }
}

export default taxConsultationsReducer
